(function () {
  const drawer = document.querySelector("[data-kbd-cart-drawer]");
  if (!drawer) return;

  const selectors = {
    bulk: "[data-kbd-cart-bulk]",
    close: "[data-kbd-cart-close]",
    items: "[data-kbd-cart-items]",
    note: "[data-kbd-cart-note]",
    removeSelected: "[data-kbd-cart-remove-selected]",
    selectAll: "[data-kbd-cart-select-all]",
    status: "[data-kbd-cart-status]",
    subtotal: "[data-kbd-cart-subtotal]"
  };

  const state = {
    cart: null,
    isOpen: false,
    noteTimer: 0
  };

  const moneyFormat = window.theme && (window.theme.moneyFormatWithCodeForCartPreference || window.theme.moneyFormat);

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function" && moneyFormat) {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : "USD";
    return new Intl.NumberFormat(document.documentElement.lang || "en", {
      style: "currency",
      currency
    }).format((Number(cents) || 0) / 100);
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function setStatus(message) {
    const status = drawer.querySelector(selectors.status);
    if (status) status.textContent = message || "";
  }

  function updateHeaderCount(cart) {
    document.querySelectorAll(".header-cart__count").forEach(count => {
      count.textContent = cart ? cart.item_count : "0";
    });
  }

  function visibleProperties(item) {
    return Object.entries(item.properties || {}).filter(([key, value]) => value && key.charAt(0) !== "_");
  }

  function renderItem(item) {
    const image = item.image
      ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title || item.title)}" loading="lazy">`
      : "";
    const variant = item.variant_title && item.variant_title !== "Default Title"
      ? `<div class="kbd-cart-drawer__meta">${escapeHtml(item.variant_title)}</div>`
      : "";
    const properties = visibleProperties(item)
      .map(([key, value]) => `<div class="kbd-cart-drawer__property">${escapeHtml(key)}: ${escapeHtml(value)}</div>`)
      .join("");
    return `
      <article class="kbd-cart-drawer__item" data-kbd-cart-item="${escapeHtml(item.key)}">
        <input class="kbd-cart-drawer__item-check" type="checkbox" data-kbd-cart-item-check value="${escapeHtml(item.key)}" aria-label="Select ${escapeHtml(item.product_title || item.title)}">
        <a class="kbd-cart-drawer__image" href="${escapeHtml(item.url || "/cart")}">${image}</a>
        <div class="kbd-cart-drawer__item-main">
          <div class="kbd-cart-drawer__item-top">
            <a class="kbd-cart-drawer__title" href="${escapeHtml(item.url || "/cart")}">${escapeHtml(item.product_title || item.title)}</a>
            <span class="kbd-cart-drawer__price">${formatMoney(item.final_line_price)}</span>
          </div>
          ${variant}
          ${properties}
          <div class="kbd-cart-drawer__item-bottom">
            <div class="kbd-cart-drawer__qty" aria-label="Quantity">
              <button type="button" data-kbd-cart-qty="${escapeHtml(item.key)}" data-kbd-cart-delta="-1" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-kbd-cart-qty="${escapeHtml(item.key)}" data-kbd-cart-delta="1" aria-label="Increase quantity">+</button>
            </div>
            <button class="kbd-cart-drawer__remove" type="button" data-kbd-cart-remove="${escapeHtml(item.key)}">Remove</button>
          </div>
        </div>
      </article>
    `;
  }

  function render(cart) {
    state.cart = cart;
    updateHeaderCount(cart);

    const items = drawer.querySelector(selectors.items);
    const subtotal = drawer.querySelector(selectors.subtotal);
    const note = drawer.querySelector(selectors.note);
    const bulk = drawer.querySelector(selectors.bulk);

    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (note && document.activeElement !== note) note.value = cart.note || "";
    if (bulk) bulk.hidden = cart.items.length === 0;

    if (!items) return;
    if (!cart.items.length) {
      items.innerHTML = "";
      setStatus("Your cart is empty.");
      return;
    }

    setStatus("");
    items.innerHTML = cart.items.map(renderItem).join("");
  }

  async function requestCart(path, options) {
    const response = await fetch(path, {
      credentials: "same-origin",
      headers: {
        "Accept": "application/json",
        ...(options && options.headers ? options.headers : {})
      },
      ...options
    });
    if (!response.ok) throw new Error("Cart update failed");
    return response.json();
  }

  async function refresh(cartOverride) {
    if (cartOverride && Array.isArray(cartOverride.items)) {
      render(cartOverride);
      return cartOverride;
    }
    setStatus("Loading cart...");
    const cart = await requestCart("/cart.js");
    render(cart);
    return cart;
  }

  async function changeLine(key, quantity) {
    setStatus("Updating cart...");
    const cart = await requestCart("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    });
    render(cart);
  }

  async function removeSelected() {
    const updates = {};
    drawer.querySelectorAll("[data-kbd-cart-item-check]:checked").forEach(input => {
      updates[input.value] = 0;
    });
    if (!Object.keys(updates).length) return;
    setStatus("Removing selected items...");
    const cart = await requestCart("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates })
    });
    render(cart);
  }

  async function findUnavailableCartItems(cart) {
    const products = new Map();
    const unavailable = [];
    for (const item of cart.items || []) {
      if (!item.handle || !item.variant_id) continue;
      try {
        if (!products.has(item.handle)) {
          products.set(item.handle, await requestCart(`/products/${item.handle}.js`));
        }
        const product = products.get(item.handle);
        const variant = (product.variants || []).find(entry => String(entry.id) === String(item.variant_id));
        if (variant && variant.available === false) unavailable.push(item);
      } catch (error) {
        // If a product JSON endpoint is blocked or unavailable, keep the item.
      }
    }
    return unavailable;
  }

  async function removeUnavailableItems(cart) {
    const unavailable = await findUnavailableCartItems(cart);
    if (!unavailable.length) return cart;
    const updates = {};
    unavailable.forEach(item => {
      updates[item.key] = 0;
    });
    setStatus(`Removed ${unavailable.length} sold out item${unavailable.length > 1 ? "s" : ""}.`);
    return requestCart("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates })
    });
  }

  async function checkout() {
    setStatus("Checking cart...");
    const cleanCart = await removeUnavailableItems(state.cart || await requestCart("/cart.js"));
    render(cleanCart);
    window.location.href = "/checkout";
  }

  function cartFromOpenInput(input) {
    if (input && input.detail && input.detail.cart) return input.detail.cart;
    if (input && Array.isArray(input.items)) return input;
    return null;
  }

  function open(input) {
    drawer.hidden = false;
    requestAnimationFrame(() => {
      drawer.classList.add("is-open");
      document.documentElement.classList.add("kbd-cart-drawer-open");
    });
    state.isOpen = true;
    const passedCart = cartFromOpenInput(input);
    if (passedCart) {
      render(passedCart);
      return;
    }
    refresh().catch(error => setStatus(error.message));
  }

  function close() {
    drawer.classList.remove("is-open");
    document.documentElement.classList.remove("kbd-cart-drawer-open");
    state.isOpen = false;
    window.setTimeout(() => {
      if (!state.isOpen) drawer.hidden = true;
    }, 240);
  }

  async function addForm(form, submitter) {
    if (submitter && submitter.name === "checkout") return false;
    const action = form.getAttribute("action") || "";
    if (!/\/cart\/add(?:\.js)?/.test(action)) return false;
    setStatus("Adding item...");
    const response = await fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Accept": "application/json" },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error("Could not add item to cart");
    await refresh();
    open();
    return true;
  }

  const originalFetch = window.fetch ? window.fetch.bind(window) : null;
  if (originalFetch) {
    window.fetch = async function kbdCartDrawerFetch(input, init) {
      const response = await originalFetch(input, init);
      try {
        const url = typeof input === "string" ? input : input && input.url ? input.url : "";
        const path = new URL(url, window.location.origin).pathname;
        const method = init && init.method ? String(init.method).toUpperCase() : "GET";
        const isThemeFormAdd = init && init.body instanceof FormData;
        if (response.ok && isThemeFormAdd && method !== "GET" && /\/cart\/add(?:\.js)?$/.test(path)) {
          window.setTimeout(() => {
            open();
          }, 80);
        }
      } catch (error) {
        // Cart drawer fallback should never break the original cart request.
      }
      return response;
    };
  }

  drawer.addEventListener("click", event => {
    const closeButton = event.target.closest(selectors.close);
    if (closeButton) {
      close();
      return;
    }

    const removeButton = event.target.closest("[data-kbd-cart-remove]");
    if (removeButton) {
      changeLine(removeButton.dataset.kbdCartRemove, 0).catch(error => setStatus(error.message));
      return;
    }

    const qtyButton = event.target.closest("[data-kbd-cart-qty]");
    if (qtyButton && state.cart) {
      const item = state.cart.items.find(cartItem => cartItem.key === qtyButton.dataset.kbdCartQty);
      if (!item) return;
      const delta = Number(qtyButton.dataset.kbdCartDelta || 0);
      changeLine(item.key, item.quantity + delta).catch(error => setStatus(error.message));
      return;
    }

    if (event.target.closest(selectors.removeSelected)) {
      removeSelected().catch(error => setStatus(error.message));
      return;
    }

    if (event.target.closest("[data-kbd-cart-checkout], .kbd-cart-drawer__checkout")) {
      event.preventDefault();
      checkout().catch(error => setStatus(error.message));
    }
  });

  drawer.addEventListener("change", event => {
    if (event.target.matches(selectors.selectAll)) {
      drawer.querySelectorAll("[data-kbd-cart-item-check]").forEach(input => {
        input.checked = event.target.checked;
      });
    }

    if (event.target.matches(selectors.note)) {
      window.clearTimeout(state.noteTimer);
      state.noteTimer = window.setTimeout(async () => {
        try {
          const cart = await requestCart("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ note: event.target.value })
          });
          render(cart);
        } catch (error) {
          setStatus(error.message);
        }
      }, 250);
    }
  });

  document.addEventListener("submit", event => {
    const form = event.target.closest("form");
    if (!form) return;
    const submitter = event.submitter || document.activeElement;
    const action = form.getAttribute("action") || "";
    if (!/\/cart\/add(?:\.js)?/.test(action)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addForm(form, submitter).catch(error => {
      setStatus(error.message);
      open();
    });
  }, true);

  document.addEventListener("click", event => {
    const cartLink = event.target.closest('a[href="/cart"], a[href$="/cart"]');
    if (!cartLink || cartLink.closest("[data-kbd-cart-drawer]")) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    open();
  });

  window.addEventListener("kbd:cart-updated", open);
  window.KBDCartDrawer = { open, close, refresh, render };
})();
